// src/components/RequireAccess.tsx
import { useEffect, useState } from "react";
import type { JSX } from "react";
import { api } from "../lib/api";
import { ROUTE } from "../lib/paths";
import { normalizeRole, isRouteAllowed, homeRouteFor, type Role } from "../lib/rbac";

type State =
  | { loading: true; role?: Role; error?: string | null }
  | { loading: false; role: Role; error?: string | null };

export default function RequireAccess({ children }: { children: JSX.Element }) {
  const [st, setSt] = useState<State>({ loading: true });

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const me = await api.me();
        if (!alive) return;

        const role = normalizeRole(me.role);
        const current = ROUTE.parse();

        if (!isRouteAllowed(current, role)) {
          ROUTE.go(homeRouteFor(role), true);
          setSt({ loading: false, role });
          return;
        }

        setSt({ loading: false, role });
      } catch (e: any) {
        const role: Role = null;
        ROUTE.go(homeRouteFor(role), true);
        setSt({ loading: false, role, error: e?.message || "error" });
      }
    })();

    return () => { alive = false; };
  }, []);

  if (st.loading) return null;
  return children;
}